import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';

export const createRseePackageRequest = reqObject => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.rseePackages
      .createRseePackageRequest(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.CREATE_RSEE_PACKAGE_REQUEST_FAILED,
            reject: actionTypes.CREATE_RSEE_PACKAGE_REQUEST_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.CREATE_RSEE_PACKAGE_REQUEST_LOADING);
  const success = res => action(actionTypes.CREATE_RSEE_PACKAGE_REQUEST_SUCCESS, res);

  return request();
};

export const editRseePackageRequest = reqObject => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.rseePackages
      .editRseePackageRequest(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_RSEE_PACKAGE_REQUEST_FAILED,
            reject: actionTypes.UPDATE_RSEE_PACKAGE_REQUEST_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.UPDATE_RSEE_PACKAGE_REQUEST_LOADING);
  const success = res => action(actionTypes.UPDATE_RSEE_PACKAGE_REQUEST_SUCCESS, res);

  return request();
};

export const getRseePackageByIdRequest = reqObject => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.rseePackages
      .getRseePackageByIdRequest(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_RSEE_PACKAGE_BY_ID_FAILED,
            reject: actionTypes.GET_RSEE_PACKAGE_BY_ID_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.GET_RSEE_PACKAGE_BY_ID_LOADING);
  const success = res => action(actionTypes.GET_RSEE_PACKAGE_BY_ID_SUCCESS, res);

  return request();
};

export const getAllRseePackagesRequest = reqObject => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.rseePackages
      .getAllRseePackagesRequest(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_ALL_RSEE_PACKAGES_REQUESTS_FAILED,
            reject: actionTypes.GET_ALL_RSEE_PACKAGES_REQUESTS_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.GET_ALL_RSEE_PACKAGES_REQUESTS_LOADING);
  const success = res => action(actionTypes.GET_ALL_RSEE_PACKAGES_REQUESTS_SUCCESS, res);

  return request();
};

export const getRseePackagesSalesReportRequest = reqObject => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.rseePackages
      .getRseePackagesSalesReportRequest(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_FAILED,
            reject: actionTypes.GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_LOADING);
  const success = res => action(actionTypes.GET_RSEE_PACKAGES_SALES_REPORT_REQUEST_SUCCESS, res);

  return request();
};

export const editRseePackageStatusRequest = reqObject => {
  const request = () => dispatch => {
    dispatch(loading());
    return API.rseePackages
      .editRseePackageStatusRequest(reqObject)
      .then(res => dispatch(success(res)))
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.UPDATE_RSEE_PACKAGE_STATUS_FAILED,
            reject: actionTypes.UPDATE_RSEE_PACKAGE_STATUS_REJECT
          })
        );
        throw err;
      });
  };
  const loading = _ => action(actionTypes.UPDATE_RSEE_PACKAGE_STATUS_LOADING);
  const success = res => action(actionTypes.UPDATE_RSEE_PACKAGE_STATUS_SUCCESS, res);

  return request();
};